var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HeartGraph"},[_c('svg',{ref:"svg",staticClass:"canvas",attrs:{"viewBox":_vm.svgViewBox}},[_c('g',{attrs:{"id":"blocksGroup"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }